import React, { useContext } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';

import { Context } from '../../../index';

import EditProfileClient from './EditProfileClient';
import EditProfileLawyer from './EditProfileLawyer';

const EditProfile = () => {
  const { firestore, auth } = useContext(Context);

  const user = auth.currentUser;
  const userId = user.uid;
  const [userPersonalData, loading] = useDocumentData(firestore.collection('users').doc(userId));

  if (loading) return null;

  return userPersonalData?.is_lawyer ? <EditProfileLawyer /> : <EditProfileClient />;
};

export default EditProfile;
